import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ToastService} from 'src/app/services/toast/toast.service';
import {ArquivoExtratoFileInputComponent} from '../importar-arquivo/arquivo-extrato-file-input.component';

@Component({
    selector: 'importar-arquivo-dialog',
    templateUrl: './importar-arquivo-dialog.component.html',
    styleUrls: ['./importar-arquivo-dialog.component.css']
})
export class ImportarArquivoDialogComponent implements OnInit {

    // File upload properties
    arquivoSelecionado: File | null = null;
    isDragOver = false;

    @ViewChild('fileInput') fileInput: ArquivoExtratoFileInputComponent;

    constructor(
        private dialogRef: MatDialogRef<ImportarArquivoDialogComponent>,
        private toastService: ToastService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        // Configurações do diálogo podem ser passadas via data
        if (data) {
            this.dialogRef.disableClose = data.disableClose || false;
        }
    }

    ngOnInit(): void {
    }

    // File upload methods
    triggerFileInput(event?: Event): void {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (this.fileInput) {
            this.fileInput.triggerClick();
        }
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = true;
    }

    onDragLeave(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;
    }

    onDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        this.isDragOver = false;

        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            this.onArquivoSelecionado(files);
        }
    }

    onArquivoSelecionado(files: FileList): void {
        if (files && files.length > 0) {
            const arquivo = files[0];

            // Validar extensão
            const nomeArquivoLower = arquivo.name.toLowerCase();
            if (!nomeArquivoLower.endsWith('.ofx') && !nomeArquivoLower.endsWith('.txt')) {
                this.toastService.showAlerta('Apenas arquivos .OFX ou .TXT são aceitos');
                return;
            }

            // Validar tamanho (máximo 10MB)
            const tamanhoMaximo = 10 * 1024 * 1024; // 10MB
            if (arquivo.size > tamanhoMaximo) {
                this.toastService.showAlerta('Arquivo muito grande. Tamanho máximo: 10MB');
                return;
            }

            this.arquivoSelecionado = arquivo;
            this.toastService.showSucesso(`Arquivo selecionado: ${arquivo.name}`);
        }
    }

    getNomeArquivo(): string {
        return this.arquivoSelecionado ? this.arquivoSelecionado.name : 'Nenhum arquivo selecionado';
    }

    getTamanhoArquivo(): string {
        if (!this.arquivoSelecionado) return '';

        const tamanho = this.arquivoSelecionado.size;
        if (tamanho < 1024) {
            return `${tamanho} bytes`;
        } else if (tamanho < 1024 * 1024) {
            return `${(tamanho / 1024).toFixed(2)} KB`;
        } else {
            return `${(tamanho / (1024 * 1024)).toFixed(2)} MB`;
        }
    }

    getFormatoArquivo(): string {
        if (!this.arquivoSelecionado) return '';
        const nomeArquivoLower = this.arquivoSelecionado.name.toLowerCase();
        if (nomeArquivoLower.endsWith('.ofx')) return 'OFX';
        return '';
    }

    limparSelecao(): void {
        this.arquivoSelecionado = null;
    }

    confirmar(): void {
        if (this.arquivoSelecionado) {
            // Retorna o arquivo selecionado para o componente pai
            this.dialogRef.close({arquivo: this.arquivoSelecionado});
        } else {
            this.toastService.showAlerta('Selecione um arquivo para continuar');
        }
    }

    voltar(): void {
        this.dialogRef.close();
    }
}
